import { apiPost, apiGet, apiReq, apiPut, randomString } from "../utils";
import qs from "query-string";
import { formTypes, authApiUrl, apiUrl } from "../constants";
import * as urls from "../config/urls";

const headers = {
  //   "Content-Type": formTypes.urlencoded,
  //   "X-Parse-Revocable-Session": 1,
  //   "X-Parse-Application-Id": formTypes.appId,
  //   'Access-Control-Allow-Origin' : '*',
  //   'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
};

export function addEditDiseaseCategoryAPI(data) {
  return apiPost(urls.CREATE_EDIT_DISEASE_CATEGORY, data);
}

export function addEditDiseaseAPI(data) {
  return apiPost(urls.CREATE_EDIT_DISEASE, data);
}

export function listDiseaseAPI(data) {
  return apiPost(urls.LIST_DISEASE, data);
}

export function listDiseaseCategoryAPI(data) {
  return apiPost(urls.LIST_DISEASE_CATEGORY, data);
}

export function deleteDiseaseCategoryAPI(data) {
  return apiPost(urls.DELETE_BLOCK_DISEASE_CATEGORY, data);
}

export function deleteDiseaseAPI(data) {
  return apiPost(urls.DELETE_BLOCK_STATUS_DISEASE, data);
}
